export default __webpack_public_path__ + "static/media/banner-bg.576b435a.png";